function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M76.3 40.715L7.5 1.015c-3.8-2.2-6.9-.7-7.4 3.3 0 .3-.1.6-.1 1v79.4c0 4.7 3.3 6.6 7.4 4.3l67.5-39 1.3-.8c4.1-2.3 4.1-6.1.1-8.5z",
  fill: "currentColor"
});

function SvgPlay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 79.288 89.991"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA3OS4yODggODkuOTkxIj4KICA8cGF0aCBkPSJNNzYuMyA0MC43MTVMNy41IDEuMDE1Yy0zLjgtMi4yLTYuOS0uNy03LjQgMy4zIDAgLjMtLjEuNi0uMSAxdjc5LjRjMCA0LjcgMy4zIDYuNiA3LjQgNC4zbDY3LjUtMzkgMS4zLS44YzQuMS0yLjMgNC4xLTYuMS4xLTguNXoiIGZpbGw9ImN1cnJlbnRDb2xvciIvPgo8L3N2Zz4=";
export { SvgPlay as ReactComponent };